
import React from 'react'



const Hero = ({ className, imageClassName, heroMDWidth, children }) => {


  return (
    <div className={`flex relative justify-center xs:min-h-hero ${className}`}>
      <div className={`z-0 h-full hero-img bg-no-repeat ${imageClassName} bg-[6rem]`}></div>
      <div className={`z-10 xs:w-full ${heroMDWidth} py-16 px-4 xl:px-0 text-center md:text-left md:bg-none self-center justify-self-center`}>
        {children}
      </div>
    </div>
  )
}

export default Hero